/* eslint-disable @typescript-eslint/no-explicit-any */
import useProfile from "@/hooks/use-profile";
import { Roles } from "@/utilities/types/Users";
import { useEffect } from "react";

const WIDGET_SRC = "https://helpdesk.project.sg/widget.js";
const WIDGET_POSITION = "bottom-right";

export default function HelpdeskWidget() {
  const { profile, loading } = useProfile();

  useEffect(() => {
    // Wait for profile to load, and skip if role is ADMIN
    if (loading || !profile || profile.role === Roles.ADMIN) return;

    // Avoid loading the script twice
    const existing = document.querySelector<HTMLScriptElement>(
      `script[src="${WIDGET_SRC}"]`,
    );
    if (existing) return;

    const script = document.createElement("script");
    script.async = true;
    script.src = WIDGET_SRC;
    // Widget only reads data-position to choose a corner.
    // It hardcodes 20px offset (button) and 90px offset (iframe) — not configurable.
    script.setAttribute("data-position", WIDGET_POSITION);
    document.head.appendChild(script);
    return () => {
      // Clean up when the user logs out or role changes
      script.remove();
    };
  }, [loading, profile]);

  return null;
}
